import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=61cdc9b5&scoped=true&"
import script from "./Cart.vue?vue&type=script&lang=js&"
export * from "./Cart.vue?vue&type=script&lang=js&"
import style0 from "./Cart.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Cart.vue?vue&type=style&index=1&id=61cdc9b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cdc9b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDivider,VFlex,VIcon,VImg,VLayout,VSimpleTable})
